<div
  class="fixed bottom-0 left-0 right-0 w-full bg-white shadow shadow-top lg:hidden kiosk:block"
  [style.z-index]="index$ | async"
  appFooterStickyModal
>
  @if (errorMessages) {
    <div>
      @for (message of errorMessages; track message) {
        <p class="mx-5 mt-5 rounded bg-error-50 px-4 py-3 font-base text-sm text-error-700">
          {{ message }}
        </p>
      }
      @if (missingLocationIdError) {
        <div>
          <p class="mx-5 mt-5 rounded bg-error-50 px-4 py-3 font-base text-sm text-error-700">
            {{ missingLocationIdError }}
          </p>
        </div>
      }
      @if (
        (cartHasProduct$ | async) &&
          !(checkCartIsValidCallInProgress$ | async) &&
          (orderValidate$ | async);
        as orderValidate
      ) {
        <div
          class="mx-auto max-w-md p-4 align-middle"
          [class.pb-7]="isNotched"
        >
          @if (!(basketId$ | async) && !!orderLength(orderValidate)) {
            <app-button-atom
              [label]="
                orderValidate[orderKeys.FinalPrice] === 0
                  ? ('basket.payment_zero' | translate)
                  : (goToPaymentButtonText | translate)
              "
              [type]="'primary'"
              [size]="'L'"
              (click)="goToPayment()"
              [disabled]="
                isGoToPaymentInProgress ||
                !!errorMessages.length ||
                !(orderHasProduct$ | async) ||
                (missingPhone$ | async) === true ||
                onSiteLocationIsMissing === true ||
                !!missingLocationIdError
              "
              [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
            ></app-button-atom>
          }
          @if (orderValidate$ | async; as orderValidate) {
            <div>
              @if (
                !!orderLength(orderValidate) &&
                (basketId$ | async) &&
                (basket$ | async)?.user?.id === (userId$ | async)
              ) {
                <app-button-atom
                  [label]="'basket.payment' | translate"
                  [type]="'primary'"
                  [size]="'L'"
                  (click)="confirmOrder()"
                  [disabled]="
                    isGoToPaymentInProgress ||
                    !!errorMessages.length ||
                    !(orderHasProduct$ | async) ||
                    (missingPhone$ | async) === true ||
                    !!missingLocationIdError
                  "
                  [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
                ></app-button-atom>
              }
              @if (
                !!orderLength(orderValidate) &&
                (basketId$ | async) &&
                (basket$ | async)?.user?.id !== (userId$ | async)
              ) {
                <app-button-atom
                  [label]="'basket.validate-order' | translate"
                  [type]="'primary'"
                  [size]="'L'"
                  (click)="confirmOrder()"
                  [disabled]="
                    isGoToPaymentInProgress ||
                    !!errorMessages.length ||
                    !(orderHasProduct$ | async) ||
                    (missingPhone$ | async) === true ||
                    !!missingLocationIdError
                  "
                  [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
                ></app-button-atom>
              }
            </div>
          }
        </div>
      }
      @if (!(orderValidate$ | async) || (checkCartIsValidCallInProgress$ | async)) {
        <div
          class="mx-auto max-w-md p-4 align-middle"
          [class.pb-7]="isNotched"
        >
          <app-button-atom
            [label]="'basket.payment' | translate"
            [type]="'primary'"
            [size]="'L'"
            [disabled]="true"
            [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
          ></app-button-atom>
        </div>
      }
    </div>
  }
</div>
